"use client";

import type { Stimulus } from "@/lib/exams/cambridge/stimulus";

// Presentational view of the Cambridge task on the result / resume screen: the
// task prompt text plus, if present, the content/input points the response had to
// cover. Indigo card styling matching the mark page.
export function CambridgeStimulusView({ stimulus }: { stimulus: Stimulus }) {
  return (
    <div className="rounded-xl border border-brand-soft bg-brand-surface p-4">
      <p className="mb-2 text-xs font-semibold tracking-wide text-brand uppercase">
        The task you answered
      </p>
      <p className="text-sm leading-relaxed whitespace-pre-line text-brand">
        {stimulus.promptText}
      </p>
      {stimulus.inputPoints && stimulus.inputPoints.length > 0 && (
        <ul className="mt-3 list-inside list-disc space-y-1">
          {stimulus.inputPoints.map((p, i) => (
            <li key={i} className="text-sm text-brand">
              {p}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
